var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-content-conatiner"},[_c('div',{staticClass:"scrollable-container",domProps:{"innerHTML":_vm._s(_vm.renderedMarkdownIt)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }